import { Social } from "./Social"
import { INSTA_URL } from "@/scripts/config/instagram.config"
import { utilities } from "@/scripts/common/utilities"
import { instaCellTpl } from './templates/instagram-cell.template'
import { LazyLoad } from '@/scripts/lazyload/Lazyload'

export class Insta extends Social.Main {
    constructor(container) {
        super(container)
        this.url = INSTA_URL
        this.init()
    }

    listingHTML() {
        const items = this.data.data

        if (this.data.data.length === 0) return
        const $wrapper = document.createElement('div')
        const $list = document.createElement('ul')
        $wrapper.classList.add('bordered-col-list')
        $list.classList.add('row', 'row--grid-gutter-lg', 'list-unstyled')
        items.forEach(item => {
            $list.appendChild(this.createCell(item))
        })
        $wrapper.appendChild($list)
        this.$container.appendChild($wrapper)
    }

    createCell(item) {
        const $singleCell = utilities.createNodeParsing(instaCellTpl())
        const imagesArray = []

        if (item.images['low_resolution'])
            imagesArray.push({
                "screen": 0,
                "src": item.images['low_resolution'].url
            })
        if (item.images['thumbnail'])
            imagesArray.push({
                "screen": 1024,
                "src": item.images['thumbnail'].url
            })
        if (item.images['standard_resolution'])
            imagesArray.push({
                "screen": 1200,
                "src": item.images['standard_resolution'].url
            })

        if (imagesArray.length === 0) return
        const $bgImg = $singleCell.querySelector('.bg-img')
        const $link = $singleCell.querySelector('a[href]')
        $link.setAttribute('href', item.link)
        $link.setAttribute('target', '_blank')
        $bgImg.setAttribute("data-image-array", `${JSON.stringify(imagesArray)}`)
        new LazyLoad($bgImg)
        return $singleCell
    }
}